import moment from 'moment';
import {
  SET_PAGE_SELECTED_CHECKBOX_STATE,
  SET_PAGE_SEARCH_TEXT,
  SET_PAGE_FILTER_VALUE,
  SET_ZERPA_TABLE_STATE,
  SET_PAGE_YEAR_VALUE,
  SET_PAGE_TYPE_VALUE,
  SET_PAGE_SELECTED_TAB,
  SET_PAGE_SHOW_DEACTIVATED,
  PageStateActionTypes,
  PageState,
  PageIdentifier,
  ZerpaState,
} from '../types';

const initialState: PageState = {
  institutemanagement: {
    selectedCheckboxIds: [],
    searchText: '',
    filterValue: '',
  },
  usermanagement: {
    selectedCheckboxIds: [],
    searchText: '',
    filterValue: '',
  },
  trialmanagement: {
    searchText: '',
    selectedCheckboxIds: [],
    year: moment().utc().format('YYYY'),
    type: [],
    showDeactivatedTrials: false,
    selectedTab: 'institute' || 'individual',
  },
  enrollmentmanagement: {
    selectedTab: 'institute' || 'individual',
    selectedCheckboxIds: [],
    searchText: '',
    filterValue: '',
  },
};

function setPageSelectedCheckbox(
  state: PageState, pageId: PageIdentifier, ids: string[] | number[],
): PageState {
  return {
    ...state,
    [pageId]: {
      ...state[pageId],
      selectedCheckboxIds: ids,
    },
  } as PageState;
}

function setPageSearchText(
  state: PageState, pageId: PageIdentifier, text: string,
): PageState {
  return {
    ...state,
    [pageId]: {
      ...state[pageId],
      searchText: text,
    },
  } as PageState;
}

function setPageFilterValue(
  state: PageState, pageId: PageIdentifier, value: string,
): PageState {
  return {
    ...state,
    [pageId]: {
      ...state[pageId],
      filterValue: value,
    },
  } as PageState;
}

function setZerpaTableState(
  state: PageState, pageId: PageIdentifier, zerpaState: ZerpaState,
): PageState {
  return {
    ...state,
    [pageId]: {
      ...state[pageId],
      zerpaTableState: zerpaState,
    },
  } as PageState;
}

function setPageYearValue(
  state: PageState, value: string,
): PageState {
  return {
    ...state,
    trialmanagement: {
      ...state.trialmanagement,
      year: value,
    },
  } as PageState;
}

function setPageTypeValue(
  state: PageState, value: number[],
): PageState {
  return {
    ...state,
    trialmanagement: {
      ...state.trialmanagement,
      type: value,
    },
  } as PageState;
}

function setPageSeletedTab(
  state: PageState,
  pageId: PageIdentifier,
  value: 'institute' | 'individual',
): PageState {
  return {
    ...state,
    [pageId]: {
      ...state[pageId],
      selectedTab: value,
    },
  } as PageState;
}

function setPageShowDeactivated(
  state: PageState, value: boolean,
): PageState {
  return {
    ...state,
    trialmanagement: {
      ...state.trialmanagement,
      showDeactivatedTrials: value,
    },
  } as PageState;
}

function PageReducer(state = initialState, action: PageStateActionTypes): PageState {
  switch (action.type) {
    case SET_PAGE_SELECTED_CHECKBOX_STATE:
      return setPageSelectedCheckbox(state, action.pageId, action.payload);
    case SET_PAGE_SEARCH_TEXT:
      return setPageSearchText(state, action.pageId, action.payload);
    case SET_PAGE_FILTER_VALUE:
      return setPageFilterValue(state, action.pageId, action.payload);
    case SET_ZERPA_TABLE_STATE:
      return setZerpaTableState(state, action.pageId, action.payload);
    case SET_PAGE_YEAR_VALUE:
      return setPageYearValue(state, action.payload);
    case SET_PAGE_TYPE_VALUE:
      return setPageTypeValue(state, action.payload);
    case SET_PAGE_SELECTED_TAB:
      return setPageSeletedTab(state, action.pageId, action.payload);
    case SET_PAGE_SHOW_DEACTIVATED:
      return setPageShowDeactivated(state, action.payload);
    default:
      return state;
  }
}

export default PageReducer;
